import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Grid, TextField, Checkbox, DialogActions, Button, Tooltip, CircularProgress } from '@mui/material';
import { IoMdCloseCircleOutline } from "react-icons/io";
import Toggle from 'react-toggle';
import ApiRequestService from '../../../component/ApiRequestService';
import { BeatLoader } from 'react-spinners';
import { NotificationManager } from 'react-notifications';
import { DEFAULT_AT_FIRST, DEFAULT_AT_LAST, DEFAULT_MASTERY_COUNT, DEFAULT_NOCQC, DEFAULT_RADNOM_SUBCATEGORY_ORDER, DEFAULT_REQUIRED, NOT_REQUIRED, REQUIRED } from '../Constants';
import { BsInfoCircleFill } from "react-icons/bs";
import HelpText from '../../../lib/help-text';

const CategoryModal = ({
    showModal,
    handleClose,
    pickedAssignment,
    pickedCategoryKey,
    pickedCategory,
    onSaveCategoryModal
}) => {

    const helpTextModel = new HelpText();

    const [subcategories, setSubcategories] = useState(null);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [masteryCount, setMasteryCount] = useState(DEFAULT_MASTERY_COUNT);
    const [noCQC, setNoCQC] = useState(DEFAULT_NOCQC);
    const [randomSubcategoryOrder, setRandomSubcategoryOrder] = useState(DEFAULT_RADNOM_SUBCATEGORY_ORDER);
    const [required, setRequired] = useState(DEFAULT_REQUIRED);
    const [atFirst, setAtFirst] = useState(DEFAULT_AT_FIRST);
    const [atLast, setAtLast] = useState(DEFAULT_AT_LAST);
    const [assignment, setAssignment] = useState(null);
    const [pageLoading, setPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [noOfQuestion, setNoOfQuestion] = useState(0);

    const [availableQuestions, setAvailableQuestions] = useState(0);

    // assignment categories
    const [categories, setCategories] = useState([]);
    const [assignmentSubcategories, setAssignmentSubcategories] = useState([]);


    useEffect(() => {
        if (pickedAssignment) {
            setAssignment(pickedAssignment);

            let categoryMasteryCountJSON = pickedAssignment?.category_mastery_count ? JSON.parse(pickedAssignment.category_mastery_count) : {};
            let categoryNocqcJSON = pickedAssignment?.category_nocqc ? JSON.parse(pickedAssignment.category_nocqc) : {};
            let randomSubcategoryOrderJSON = pickedAssignment?.random_subcategory_order ? JSON.parse(pickedAssignment.random_subcategory_order) : {};
            let categoryIsRequiredJSON = pickedAssignment?.category_is_required ? JSON.parse(pickedAssignment.category_is_required) : {};
            let categoryPositionJSON = pickedAssignment?.category_position ? JSON.parse(pickedAssignment.category_position) : {};
            let categoryNoOfQuestionsJSON = pickedAssignment?.category_number_of_questions ? JSON.parse(pickedAssignment.category_number_of_questions) : {};

            let assignmentSubcategoriesArr = pickedAssignment.quiz_subcat_info;
            if (assignmentSubcategoriesArr) {
                assignmentSubcategoriesArr.sort((subcat1, subcat2) => {
                    return subcat1.order - subcat2.order;
                })
            } else {
                assignmentSubcategoriesArr = [];
            }
            setAssignmentSubcategories(assignmentSubcategoriesArr);

            let categoriesArr = [];
            let seenCategoryKeys = new Set();
            if (pickedAssignment && pickedAssignment.quiz_details) {
                pickedAssignment.quiz_details.forEach(category => {
                    const catKey = `${category.subject_id}_${category.topic_id}_${category.category_id}`;
                    if (!seenCategoryKeys.has(catKey)) {
                        let cat = {
                            ...category,
                            masteryCount: categoryMasteryCountJSON[catKey] ? categoryMasteryCountJSON[catKey] : DEFAULT_MASTERY_COUNT,
                            nocqc: categoryNocqcJSON[catKey] ? categoryNocqcJSON[catKey] : DEFAULT_NOCQC,
                            randomSubcategoryOrder: randomSubcategoryOrderJSON[catKey] ? randomSubcategoryOrderJSON[catKey] : DEFAULT_RADNOM_SUBCATEGORY_ORDER,
                            required: categoryIsRequiredJSON[catKey] ? categoryIsRequiredJSON[catKey] : DEFAULT_REQUIRED,
                            atFirst: categoryPositionJSON[catKey] ? categoryPositionJSON[catKey].category_at_begining : DEFAULT_AT_FIRST,
                            atLast: categoryPositionJSON[catKey] ? categoryPositionJSON[catKey].category_at_last : DEFAULT_AT_LAST,
                            noOfQuestion: categoryNoOfQuestionsJSON[catKey] ? categoryNoOfQuestionsJSON[catKey] : 0,
                        }
                        categoriesArr.push(cat);
                    }
                    seenCategoryKeys.add(catKey);
                })
            }
            getAllSubCategories();

            // Check if pickedCategory key exists in categoriesArr if not then add a new category
            // because this means user is adding a new category
            let existCategoryIndex = categoriesArr.findIndex(cat => {
                const catKey = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
                return catKey === pickedCategoryKey;
            })
            if (existCategoryIndex === -1) {
                categoriesArr.push({
                    ...pickedCategory,
                    masteryCount: DEFAULT_MASTERY_COUNT,
                    nocqc: DEFAULT_NOCQC,
                    randomSubcategoryOrder: DEFAULT_RADNOM_SUBCATEGORY_ORDER,
                    required: DEFAULT_REQUIRED,
                    atFirst: DEFAULT_AT_FIRST,
                    atLast: DEFAULT_AT_LAST,
                    noOfQuestion: 0,
                })
            }
            //console.debug("pickedCategory>>??", pickedCategory)
            setCategories(categoriesArr);

        }
    }, [pickedAssignment, pickedCategoryKey])

    /*  useEffect(() => {
         if (assignment && pickedCategoryKey) {
 
             let categoryMasteryCountJSON = JSON.parse(assignment.category_mastery_count?.trim() ? assignment.category_mastery_count : "{}");
             let randomSubcategoryOrderJSON = JSON.parse(assignment.random_subcategory_order?.trim() ? assignment.random_subcategory_order : "{}");
             let categoryIsRequiredJSON = JSON.parse(assignment.category_is_required?.trim() ? assignment.category_is_required : "{}");
             let categoryPositionJSON = JSON.parse(assignment.category_position?.trim() ? assignment.category_position : "{}");
             let categoryNocqcJSON = assignment.category_nocqc ? JSON.parse(assignment.category_nocqc) : {};
             let categoryNoOfQuestJSON = assignment.category_number_of_questions ? JSON.parse(assignment.category_number_of_questions) : {};
 
             setMasteryCount(categoryMasteryCountJSON[pickedCategoryKey] ? categoryMasteryCountJSON[pickedCategoryKey] : DEFAULT_MASTERY_COUNT);
             setRandomSubcategoryOrder(randomSubcategoryOrderJSON[pickedCategoryKey] ?? DEFAULT_RADNOM_SUBCATEGORY_ORDER);
             setRequired(categoryIsRequiredJSON[pickedCategoryKey] ?? DEFAULT_REQUIRED);
             setAtFirst(categoryPositionJSON[pickedCategoryKey]?.category_at_begining ?? DEFAULT_AT_FIRST);
             setAtLast(categoryPositionJSON[pickedCategoryKey]?.category_at_last ?? DEFAULT_AT_LAST);
             setNoCQC(categoryNocqcJSON[pickedCategoryKey] ?? DEFAULT_NOCQC);
             setNoOfQuestion(categoryNoOfQuestJSON[pickedCategoryKey] ?? 0);
 
         }
     }, [assignment]) */

    const getAllSubCategories = () => {
        let keyArr = pickedCategoryKey.split("_");
        if (keyArr && keyArr.length === 3) {
            setPageLoading(true);
            let payload = {
                subject_id: parseInt(keyArr[0], 10),
                topic_id: parseInt(keyArr[1], 10),
                category_id: parseInt(keyArr[2], 10),
            }
            ApiRequestService({
                method: 'post',
                url: '/getAllSubCategories',
                data: payload
            }).then(res => {
                if (res && res.data && res.data.data) {
                    let updatedSubcategories = [];

                    let updatedAvailableQuestions = 0;
                    let checkedSucbategoriesCount = 0
                    res.data.data.subCategory_names.map(subcategory => {
                        let catKey = `${subcategory.subject_id}_${subcategory.topic_id}_${subcategory.category_id}_${subcategory.subcategory_id}`;
                        let subcatInfo = pickedAssignment?.quiz_subcat_info?.find(subcat_info => {
                            let key = `${subcat_info.subject_id}_${subcat_info.topic_id}_${subcat_info.category_id}_${subcat_info.subcategory_id}`;
                            return key === catKey;
                        });
                        //console.debug("subcatInfo>>??", subcatInfo)
                        if (subcatInfo) {
                            updatedSubcategories.push({
                                ...subcategory,
                                ...subcatInfo,
                                checked: true,
                            })
                            checkedSucbategoriesCount++;
                            updatedAvailableQuestions += subcatInfo.question_count;
                        } else {
                            updatedSubcategories.push({
                                ...subcategory,
                                randomize_questions: 1,
                                non_graded: 0,
                                subcategory_weight: 1,
                                checked: false,
                            })
                        }
                    })

                    if (checkedSucbategoriesCount === updatedSubcategories.length) {
                        setIsAllSelected(true);
                    }

                    setSubcategories(updatedSubcategories);
                    //console.debug("updatedAvailableQuestions>>??", updatedAvailableQuestions)
                    setAvailableQuestions(updatedAvailableQuestions);
                }
            }).finally(() => {
                setPageLoading(false);
            })
        }
    }

    const handleSelectSubcategory = (event, subcatIndex) => {
        let checked = event.target.checked;
        let updatedSubcategories = [...subcategories];
        updatedSubcategories[subcatIndex].checked = checked;
        setSubcategories(updatedSubcategories);

        let totAvailableQuestions = 0;
        let totalSelected = 0;
        updatedSubcategories.forEach(subCat => {
            if (subCat.checked) {
                totAvailableQuestions += subCat.question_count;
                totalSelected++;
            }
        });
        setAvailableQuestions(totAvailableQuestions);
        if (totalSelected == 0) {
            setNoOfQuestion(0);
        }

        // Add subcat to assignment quiz_details
        // loop through all updatedSubcategories, and update quiz_details
        /* let quizDetailsArr = []
        updatedSubcategories.forEach(subcat => {
            if (subcat.checked) {
                let quiz_detail = {
                    subject_id: subcat.subject_id,
                    topic_id: subcat.topic_id,
                    category_id: subcat.category_id,
                    subcategory_id: subcat.subcategory_id,
                    index: "",
                    order: 1,
                    quiz_id: assignment.quiz_id,
                    randomize_questions: subcat.randomize_questions,
                    category_name: "",
                    subcategory_name: subcat.subcategory_name,
                    subcategory_weight: subcat.subcategory_weight ? subcat.subcategory_weight : 1, // NOCQSC
                    non_graded: subcat.non_graded,
                    enable_analytics: subcat.enable_analytics,
                    enable_feedback: subcat.enable_feedback,
                    question_count: 20
                };
                quizDetailsArr.push(quiz_detail);
            }
        })

        let updatedAssignment = { ...assignment };
        updatedAssignment.quiz_details = quizDetailsArr;
        setAssignment(updatedAssignment); */
    }

    const handleMasteryConditionChange = (value) => {
        if (value === "0") value = 1;
        /* let obj = {
            [pickedCategoryKey]: parseInt(value)
        }
        let updatedAssignment = {
            ...assignment,
            category_mastery_count: JSON.stringify(obj)
        }
        setAssignment(updatedAssignment); */
        setMasteryCount(parseInt(value));
    }

    const handleNocqcChange = (value) => {
        if (value === "0") value = 1;
        /* let obj = {
            [pickedCategoryKey]: parseInt(value)
        }
        let updatedAssignment = {
            ...assignment,
            category_nocqc: JSON.stringify(obj)
        }
        setAssignment(updatedAssignment); */
        setNoCQC(parseInt(value));
    }

    const handleNoOfQuestionsChange = (value) => {
        if (value === "0") value = 1;
        let updatedValue = parseInt(value);
        if (updatedValue <= availableQuestions) {
            setNoOfQuestion(updatedValue);
        } else {
            NotificationManager.warning("You have entered more than the available # of questions in this category", "WARNING", 5000);
            setNoOfQuestion(availableQuestions);
        }
    }

    const handleRandomSubcategoryOrderChange = () => {
        let updatedValue = randomSubcategoryOrder === 1 ? 0 : 1;
        /* let obj = {
            [pickedCategoryKey]: parseInt(updatedValue)
        }
        let updatedAssignment = {
            ...assignment,
            random_subcategory_order: JSON.stringify(obj)
        }
        setAssignment(updatedAssignment); */
        setRandomSubcategoryOrder(updatedValue);
    }

    const handleRequiredChange = () => {
        let updatedValue = required === 1 ? 0 : 1;
        if (updatedValue === 0) {
            setAtFirst(0);
            setAtLast(0);
        }
        /* let obj = {
            [pickedCategoryKey]: parseInt(updatedValue)
        }
        let updatedAssignment = {
            ...assignment,
            category_is_required: JSON.stringify(obj)
        }
        if (updatedValue === 0) { // Turn of atfirst and atlast
            let categoryPosition = {
                [pickedCategoryKey]: {
                    category_at_begining: 0,
                    category_at_last: 0,
                },

            }
            updatedAssignment.category_position = JSON.stringify(categoryPosition);
        }
        setAssignment(updatedAssignment); */
        setRequired(updatedValue);
    }

    const handleAtFirstChange = () => {
        let updatedValue = atFirst === 1 ? 0 : 1;
        if (updatedValue === 1) {
            setRequired(1);
            setAtLast(0);
        }
        /* let obj = {
            [pickedCategoryKey]: {
                category_at_begining: parseInt(updatedValue),
                category_at_last: updatedValue === 1 ? 0 : atLast,
            }
        }
        let updatedAssignment = {
            ...assignment,
            category_position: JSON.stringify(obj)
        }
        if (updatedValue === 1) {
            let categoryIsRequired = {
                [pickedCategoryKey]: 1
            }
            updatedAssignment.category_is_required = JSON.stringify(categoryIsRequired);
        }
        //console.debug("updatedAssignment??", updatedAssignment)
        setAssignment(updatedAssignment); */
        setAtFirst(updatedValue);
    }

    const handleAtLastChange = () => {
        let updatedValue = atLast === 1 ? 0 : 1;
        if (updatedValue === 1) {
            setRequired(1);
            setAtFirst(0);
        }

        /* let obj = {
            [pickedCategoryKey]: {
                category_at_begining: updatedValue === 1 ? 0 : atFirst,
                category_at_last: parseInt(updatedValue),
            }
        }
        let updatedAssignment = {
            ...assignment,
            category_position: JSON.stringify(obj)
        }

        if (updatedValue === 1) {
            let categoryIsRequired = {
                [pickedCategoryKey]: 1
            }
            updatedAssignment.category_is_required = JSON.stringify(categoryIsRequired);
        }
        setAssignment(updatedAssignment); */
        setAtLast(updatedValue);
    }

    const handleUpdateAssignment = () => {

        // Get only the selected subcategories
        let selectedSubcategories = [];
        subcategories.forEach(subcat => {
            if (subcat.checked) {
                selectedSubcategories.push(subcat);
            }
        })

        if (selectedSubcategories.length === 0) {
            NotificationManager.error("Please select atleast 1 subcategory", "ERROR!", 5000);
            return;
        }

        let quizDetailsArr = [];

        let otherSubcategories = [];
        assignmentSubcategories.forEach(subcat => {
            let key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
            if (key !== pickedCategoryKey) {
                otherSubcategories.push(subcat);
            }
        })
        quizDetailsArr.push(...otherSubcategories);

        selectedSubcategories.forEach(subcat => {
            let questionCount = subcat.question_count;
            if (pickedAssignment?.quiz_type === 1 && noOfQuestion != 0) {
                questionCount = noOfQuestion;
            }
            let quiz_detail = {
                subject_id: subcat.subject_id,
                topic_id: subcat.topic_id,
                category_id: subcat.category_id,
                subcategory_id: subcat.subcategory_id,
                index: "",
                order: 1,
                quiz_id: assignment.quiz_id,
                randomize_questions: subcat.randomize_questions,
                category_name: "",
                subcategory_name: subcat.subcategory_name,
                category_name: pickedCategory.category_name,
                subcategory_weight: subcat.subcategory_weight ? subcat.subcategory_weight : 1, // NOCQSC
                non_graded: subcat.non_graded,
                enable_analytics: subcat.enable_analytics ? subcat.enable_analytics : false,
                enable_feedback: subcat.enable_feedback ? subcat.enable_feedback : false,
                question_count: questionCount,
                subject_name: pickedCategory.subject_name,
                topic_name: pickedCategory.topic_name,
            };
            quizDetailsArr.push(quiz_detail);
        })

        // Calculate the correct order based on category at first or at last
        let updatedSubcategories = [];

        const atFirstKeys = new Set();
        const atLastKeys = new Set();

        categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            if (cat.atFirst) atFirstKeys.add(key);
            else if (cat.atLast) atLastKeys.add(key);
        });

        let middleSubcats = [];
        let lastSubcats = [];
        let order = 1;

        // Get all other subcategories except this category's subcategories
        quizDetailsArr.forEach(subcat => {
            const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

            if (atFirstKeys.has(key)) {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            } else if (atLastKeys.has(key)) {
                lastSubcats.push(subcat);
            } else {
                middleSubcats.push(subcat);
            }
        });

        middleSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        lastSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        quizDetailsArr = updatedSubcategories;

        // 

        let deleteArr = [];
        if (quizDetailsArr && quizDetailsArr.length) {
            deleteArr.push(...quizDetailsArr)
        }
        if (assignment.quiz_details && assignment.quiz_details.length) {
            deleteArr.push(...assignment.quiz_details)
        }

        /* let otherCategoryDetails = [];
        if (assignment.quiz_details && assignment.quiz_details.length) {
            otherCategoryDetails = assignment.quiz_details.filter(detail => {
                const key = `${detail.subject_id}_${detail.topic_id}_${detail.category_id}`;
                return key != pickedCategoryKey;
            });
        }
        quizDetailsArr = [...otherCategoryDetails, ...quizDetailsArr]; */

        let payload = {
            ...assignment,
            sections_list: null,
            quiz_details: quizDetailsArr,
            quiz_subcat_info: quizDetailsArr,
            quiz_delete_arr: deleteArr,
            quiz_id: assignment.quiz_id,
        }

        let categoryIndex = categories.findIndex(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            return key === pickedCategoryKey;
        })
        if (categoryIndex === -1) {
            NotificationManager.error("Something went wrong", "ERROR!", 5000);
            return;
        }

        let categoryMasteryCountJSON = {};
        categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            categoryMasteryCountJSON[key] = cat.masteryCount;
        })

        let categoryNocqcJSON = {};
        categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            categoryNocqcJSON[key] = cat.nocqc;
        })

        let randomSubcategoryOrderJSON = {};
        categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            randomSubcategoryOrderJSON[key] = cat.randomSubcategoryOrder;
        })

        let categoryIsRequiredJSON = {};
        categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            categoryIsRequiredJSON[key] = cat.required;
        })

        let categoryNoOfQuestionsJSON = {};
        categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            categoryNoOfQuestionsJSON[key] = cat.noOfQuestion !== 0 ? cat.noOfQuestion : availableQuestions;
        })

        let categoryPositionJSON = {};
        categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            categoryPositionJSON[key] = {
                category_at_begining: cat.atFirst,
                category_at_last: cat.atLast,
            };
        })

        payload = {
            ...payload,
            category_mastery_count: JSON.stringify(categoryMasteryCountJSON),
            category_nocqc: JSON.stringify(categoryNocqcJSON),
            random_subcategory_order: JSON.stringify(randomSubcategoryOrderJSON),
            category_is_required: JSON.stringify(categoryIsRequiredJSON),
            category_number_of_questions: JSON.stringify(categoryNoOfQuestionsJSON),
            category_position: JSON.stringify(categoryPositionJSON),
        }

        // TODO: check if payload is valid
        // check if category no. of questions < available questions - only for test

        if (availableQuestions === 0) {
            NotificationManager.error("There are no questions availabe in the selected subcategories");
            return;
        }

        if (payload.quiz_type === 1) {
            let category = categories.find(cat => {
                const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
                return key === pickedCategoryKey;
            })
            if (category) {
                if ((category.noOfQuestion > availableQuestions) || (category.nocqc > availableQuestions)) {
                    NotificationManager.error("You have entered more than the available # of questions in the category");
                    return;
                }
            } else {
                NotificationManager.error("Something went wrong");
                return;
            }
        }

        updateAssignment(payload);
    }

    const updateAssignment = (payload) => {
        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/addQuiz',
            data: payload
        }).then(res => {
            //console.debug("res>>??", res);
            if (res && res.data && res.data.data) {
                NotificationManager.success("Saved successully", "Success", 5000)
                onSaveCategoryModal({
                    ...res.data.data,
                    sections_list: assignment.sections_list,
                });
            }
        }).finally(() => {
            setLoading(false);
        })
    }


    const handleSelectAllSubcategories = (selected) => {
        if (selected) {
            let updatedSubcategories = [];
            updatedSubcategories = subcategories.map(subCat => {
                return {
                    ...subCat,
                    checked: true,
                }
            })
            let totAvailableQuestions = 0;
            updatedSubcategories.forEach(subCat => {
                totAvailableQuestions += subCat.question_count;
            });
            setAvailableQuestions(totAvailableQuestions);
            setSubcategories(updatedSubcategories);
        } else {
            let updatedSubcategories = [];
            updatedSubcategories = subcategories.map(subCat => {
                return {
                    ...subCat,
                    checked: false,
                }
            })
            setAvailableQuestions(0);
            setSubcategories(updatedSubcategories);
        }
        setIsAllSelected(selected);
    }

    return (
        <Dialog
            open={showModal}
            maxWidth={false}
            // fullWidth
            PaperProps={{
                sx: {
                    // minHeight: 600
                    width: 'auto'
                }
            }}
        >
            <DialogTitle>
                <Typography fontSize={18} fontWeight={500}>
                    <span style={{ color: "#bb0000", fontWeight: 600 }}>{pickedAssignment?.quiz_name} / </span>
                    <span>Alg. operations: Division of Fractions</span>
                </Typography>
            </DialogTitle>
            <IconButton
                aria-label="close"
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
                onClick={handleClose}
            >
                <IoMdCloseCircleOutline fontSize={24} />
            </IconButton>
            <div style={{ position: "relative" }}>


                {pageLoading ?
                    <div className='abs-loader'>
                        <BeatLoader color='#bb0000' loading={true} size={10} />
                    </div>
                    : null}
                <DialogContent>
                    <span className='category-option-header'>
                        Category Option:
                    </span>

                    {/* CATEGORY OPTION START */}
                    <div className='matrix-table-container category-option-table'>
                        <table className="matrix-table">
                            <thead className='matrix-table-head'>
                                {assignment?.quiz_type === 0 ?
                                    <tr className="matrix-row-header">
                                        <th className="matrix-row-cell ">Subject</th>
                                        <th className="matrix-row-cell ">Topic</th>
                                        <th className="matrix-row-cell ">Category</th>
                                        <th
                                            key={0}
                                            className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}
                                        >
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"Mastery Condition"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"NOCQC"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "180px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"Random Subcategory Order"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"Required"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"At First"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"At Last"} />
                                            </div>
                                        </th>
                                    </tr>

                                    :
                                    <tr className="matrix-row-header">
                                        <th className="matrix-row-cell ">Subject</th>
                                        <th className="matrix-row-cell ">Topic</th>
                                        <th className="matrix-row-cell ">Category</th>
                                        <th
                                            key={0}
                                            className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}
                                        >
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"NOCQC"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "180px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"# of Questions"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "160px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"# of Available Questions"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "180px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"Random Subcategory Order"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"At First"} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name={"At Last"} />
                                            </div>
                                        </th>
                                    </tr>
                                }
                            </thead>
                            <tbody>
                                {categories.map((category, index) => {
                                    const catKey = `${category.subject_id}_${category.topic_id}_${category.category_id}`;
                                    //console.debug("category>>??", category)
                                    let disabled = false;
                                    if (pickedCategoryKey !== catKey) {
                                        disabled = true;
                                        return null;
                                    }
                                    return (
                                        <tr className={`${disabled ? "matrix-row disabled-row-box" : "matrix-row"}`} key={index}>
                                            <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "200px" }}>
                                                <div className='category-name-cell'>
                                                    <div className='category-name'>
                                                        {pickedCategory?.subject_name}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "200px" }}>
                                                <div className='category-name-cell'>
                                                    <div className='category-name'>
                                                        {pickedCategory?.topic_name}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "200px" }}>
                                                <div className='category-name-cell'>
                                                    <div className='category-name'>
                                                        {category.category_name}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="matrix-row-cell">
                                                {assignment?.quiz_type === 1 ?
                                                    <TextField size='small' type="number" sx={{ width: "50px" }} value={parseInt(category.nocqc)}
                                                        onChange={e => {
                                                            let updatedValue = parseInt(e.target.value);
                                                            if (updatedValue <= 0) updatedValue = 1;
                                                            let updatedCategories = [...categories];
                                                            updatedCategories[index].nocqc = updatedValue;
                                                            setCategories(updatedCategories)
                                                        }}
                                                    />
                                                    :
                                                    <TextField size='small' type="number" sx={{ width: "50px" }}
                                                        value={parseInt(category.masteryCount)}
                                                        onChange={e => {
                                                            let updatedValue = parseInt(e.target.value);
                                                            if (updatedValue <= 0) updatedValue = 1;
                                                            let updatedCategories = [...categories];
                                                            updatedCategories[index].masteryCount = updatedValue;
                                                            setCategories(updatedCategories)
                                                        }}
                                                    />
                                                }
                                            </td>
                                            <td className="matrix-row-cell">
                                                {assignment?.quiz_type === 1 ?
                                                    <TextField size='small' type="number" sx={{ width: "50px" }}
                                                        value={parseInt(category.noOfQuestion)}
                                                        onChange={e => {
                                                            let updatedValue = parseInt(e.target.value);
                                                            if (updatedValue <= 0 || updatedValue >= availableQuestions) updatedValue = availableQuestions;
                                                            let updatedCategories = [...categories];
                                                            updatedCategories[index].noOfQuestion = updatedValue;
                                                            setCategories(updatedCategories)
                                                        }}
                                                    />
                                                    :
                                                    <TextField size='small' type="number" sx={{ width: "50px" }} value={parseInt(category.nocqc)}
                                                        onChange={e => {
                                                            let updatedValue = parseInt(e.target.value);
                                                            if (updatedValue <= 0) updatedValue = 1;
                                                            let updatedCategories = [...categories];
                                                            updatedCategories[index].nocqc = updatedValue;
                                                            setCategories(updatedCategories)
                                                        }}
                                                    />
                                                }
                                            </td>
                                            <td className="matrix-row-cell">
                                                {assignment?.quiz_type === 1 ? (category.question_count && availableQuestions < category.question_count ? category.question_count : availableQuestions) :
                                                    <Toggle checked={category.randomSubcategoryOrder === 1} icons={false} className='custom-react-toggle'
                                                        onChange={() => {
                                                            let updatedValue = category.randomSubcategoryOrder === 1 ? 0 : 1;
                                                            let updatedCategories = [...categories];
                                                            updatedCategories[index].randomSubcategoryOrder = updatedValue;
                                                            setCategories(updatedCategories)
                                                        }}
                                                    />
                                                }
                                            </td>
                                            <td className="matrix-row-cell">
                                                {assignment?.quiz_type === 1 ? <Toggle checked={category.randomSubcategoryOrder === 1} icons={false} className='custom-react-toggle' /> :
                                                    <Toggle checked={category.required === REQUIRED} icons={false} className='custom-react-toggle'
                                                        onChange={() => {
                                                            let updatedValue = category.required === REQUIRED ? NOT_REQUIRED : REQUIRED;
                                                            let updatedCategories = [...categories];
                                                            if (updatedValue === NOT_REQUIRED) {
                                                                updatedCategories[index].atFirst = 0;
                                                                updatedCategories[index].atLast = 0;
                                                            }
                                                            updatedCategories[index].required = updatedValue;

                                                            setCategories(updatedCategories)
                                                        }}
                                                    />
                                                }
                                            </td>
                                            <td className="matrix-row-cell">
                                                <Toggle checked={category.atFirst === 1} icons={false} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = category.atFirst === 1 ? 0 : 1;
                                                        let updatedCategories = [...categories];
                                                        if (updatedValue == 1) {
                                                            for (let i = 0; i < updatedCategories.length; i++) {
                                                                updatedCategories[i].atFirst = 0;
                                                                // updatedCategories[i].atLast = 0;
                                                            }
                                                            updatedCategories[index].required = 1;
                                                            updatedCategories[index].atLast = 0;
                                                        }

                                                        updatedCategories[index].atFirst = updatedValue;

                                                        if (updatedValue === 1) {
                                                            let temp = updatedCategories[0];
                                                            updatedCategories[0] = updatedCategories[index];
                                                            updatedCategories[index] = temp
                                                        }

                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            </td>
                                            <td className="matrix-row-cell">
                                                <Toggle checked={category.atLast === 1} icons={false} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = category.atLast === 1 ? 0 : 1;
                                                        let updatedCategories = [...categories];
                                                        if (updatedValue == 1) {
                                                            for (let i = 0; i < updatedCategories.length; i++) {
                                                                // updatedCategories[i].atFirst = 0;
                                                                updatedCategories[i].atLast = 0;
                                                            }
                                                            updatedCategories[index].required = 1;
                                                            updatedCategories[index].atFirst = 0;
                                                        }
                                                        updatedCategories[index].atLast = updatedValue;

                                                        if (updatedValue === 1) {
                                                            let l = updatedCategories.length;
                                                            let temp = updatedCategories[l - 1];
                                                            updatedCategories[l - 1] = updatedCategories[index];
                                                            updatedCategories[index] = temp
                                                        }

                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* CATEGORY OPTION END */}

                    {/* <div className='category-option-container'>
                        {assignment?.quiz_type === 1 ? // TEST
                            <React.Fragment>
                                <div className='category-option'>
                                    <Header name={"NOCQC"} />
                                    <TextField type='number' size='small'
                                        onChange={event => {
                                            handleNocqcChange(event.target.value);
                                        }}
                                        value={noCQC} inputProps={{ min: 1 }} sx={{ width: "60px" }} />
                                </div>
                                <div className='category-option'>
                                    <Header name={"# of Questions"} />
                                    <TextField type='number' size='small' value={noOfQuestion}
                                        onChange={event => {
                                            handleNoOfQuestionsChange(event.target.value);
                                        }}
                                        disabled={availableQuestions === 0}
                                        inputProps={{ min: 1 }}
                                        sx={{
                                            width: "60px",
                                            '& .MuiInputBase-root.Mui-disabled': {
                                                backgroundColor: '#f5f5f5', // or any light grey
                                            }
                                        }} />
                                </div>
                                <div className='category-option'>
                                    <Header name={"# of Available Questions"} />
                                    <div style={{
                                        fontSize: '18px',
                                    }}>
                                        {availableQuestions}
                                    </div>
                                </div>
                                <div className='category-option'>
                                    <Header name={"Random Subcategory Order"} />
                                    <Toggle icons={false} checked={randomSubcategoryOrder === 1} className='custom-react-toggle'
                                        onChange={() => {
                                            let obj = {
                                                [pickedCategoryKey]: parseInt(randomSubcategoryOrder === 1 ? 0 : 1)
                                            }
                                            let updatedAssignment = {
                                                ...assignment,
                                                random_subcategory_order: JSON.stringify(obj)
                                            }
                                            setAssignment(updatedAssignment);
                                        }}
                                    />
                                </div>
                                <div className='category-option'>
                                    <Header name={"At First"} />
                                    <Toggle icons={false} checked={atFirst === 1} className='custom-react-toggle'
                                        onChange={() => {
                                            let updatedValue = atFirst === 1 ? 0 : 1;
                                            let obj = {
                                                [pickedCategoryKey]: {
                                                    category_at_begining: parseInt(updatedValue),
                                                    category_at_last: updatedValue === 1 ? 0 : atLast,
                                                }
                                            }
                                            let updatedAssignment = {
                                                ...assignment,
                                                category_position: JSON.stringify(obj)
                                            }
                                            if (updatedValue === 1) {
                                                let categoryIsRequired = {
                                                    [pickedCategoryKey]: 1
                                                }
                                                updatedAssignment.category_is_required = JSON.stringify(categoryIsRequired);
                                            }
                                            //console.debug("updatedAssignment??", updatedAssignment)
                                            setAssignment(updatedAssignment);
                                        }}
                                    />
                                </div>
                                <div className='category-option'>
                                    <Header name={"At Last"} />
                                    <Toggle icons={false} checked={atLast === 1} className='custom-react-toggle'
                                        onChange={() => {
                                            let updatedValue = atLast === 1 ? 0 : 1;
                                            let obj = {
                                                [pickedCategoryKey]: {
                                                    category_at_begining: updatedValue === 1 ? 0 : atFirst,
                                                    category_at_last: parseInt(updatedValue),
                                                }
                                            }
                                            let updatedAssignment = {
                                                ...assignment,
                                                category_position: JSON.stringify(obj)
                                            }

                                            if (updatedValue === 1) {
                                                let categoryIsRequired = {
                                                    [pickedCategoryKey]: 1
                                                }
                                                updatedAssignment.category_is_required = JSON.stringify(categoryIsRequired);
                                            }
                                            setAssignment(updatedAssignment);
                                        }}
                                    />
                                </div>
                            </React.Fragment>
                            :
                            // QUIZ
                            <React.Fragment>
                                <div className='category-option'>
                                    <Header name={"Mastery Condition"} />
                                    <TextField type='number' size='small'
                                        inputProps={{ min: 1 }}
                                        onChange={event => {
                                            handleMasteryConditionChange(event.target.value);
                                        }}
                                        value={masteryCount} sx={{ width: "60px" }} />
                                </div>
                                <div className='category-option'>
                                    <Header name={"NOCQC"} />
                                    <TextField type='number' size='small'
                                        onChange={event => {
                                            handleNocqcChange(event.target.value);
                                        }}
                                        value={noCQC} inputProps={{ min: 1 }} sx={{ width: "60px" }} />
                                </div>
                                <div className='category-option'>
                                    <Header name={"Random Subcategory Order"} />
                                    <Toggle icons={false} checked={randomSubcategoryOrder === 1} className='custom-react-toggle'
                                        onChange={handleRandomSubcategoryOrderChange}
                                    />
                                </div>
                                <div className='category-option'>
                                    <Header name={"Required"} />
                                    <Toggle icons={false} checked={required === 1} className='custom-react-toggle'
                                        onChange={handleRequiredChange}
                                    />
                                </div>
                                <div className='category-option'>
                                    <Header name={"At First"} />
                                    <Toggle icons={false} checked={atFirst === 1} className='custom-react-toggle'
                                        onChange={handleAtFirstChange}
                                    />
                                </div>
                                <div className='category-option'>
                                    <Header name={"At Last"} />
                                    <Toggle icons={false} checked={atLast === 1} className='custom-react-toggle'
                                        onChange={handleAtLastChange}
                                    />
                                </div>
                            </React.Fragment>
                        }
                    </div> */}

                    <div style={{ marginTop: '2rem', marginBottom: '1rem' }}>
                        <div style={{ fontWeight: 'bold', color: '#000', fontSize: '16px' }}>Subcategories Table:</div>
                    </div>

                    <div className='matrix-table-container category-table'>
                        <table className="matrix-table">
                            <thead className='matrix-table-head'>
                                <tr className="matrix-row-header">
                                    <th className="matrix-row-cell">No.</th>
                                    <th className="matrix-row-cell">
                                        <Tooltip
                                            title={<Typography className='text-white' fontSize={14}>
                                                Select All
                                            </Typography>}
                                            placement='top'
                                            arrow
                                        >
                                            <Checkbox size='small' checked={isAllSelected}
                                                onClick={(event) => {
                                                    let updatedValue = !isAllSelected;
                                                    handleSelectAllSubcategories(updatedValue);
                                                }}
                                            />
                                        </Tooltip>
                                    </th>
                                    <th className="matrix-row-cell category-width" >
                                        <div style={{ width: '100%', }}>
                                            Subcategories
                                        </div>
                                    </th>
                                    <th
                                        key={0}
                                        className="matrix-row-cell"
                                        style={{
                                            minWidth: "140px",
                                        }}
                                    >
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            <Header name="Random question order" tooltip={helpTextModel.getHelpTextForKey('Random question order')} />
                                        </div>
                                    </th>
                                    <th className="matrix-row-cell"
                                        style={{
                                            minWidth: "100px",
                                        }}>
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            <Header name="NOCQSC" tooltip={helpTextModel.getHelpTextForKey('Weights')} />
                                        </div>
                                    </th>
                                    <th className="matrix-row-cell"
                                        style={{
                                            minWidth: "100px",
                                        }}>
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            <Header name="Available Questions" tooltip={helpTextModel.getHelpTextForKey('Available_Subcategory_Questions')} />
                                        </div>
                                    </th>
                                    <th className="matrix-row-cell"
                                        style={{
                                            minWidth: "100px",
                                        }}>
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            <Header name="Graded" tooltip={helpTextModel.getHelpTextForKey('Graded')} />
                                        </div>
                                    </th>
                                    <th className="matrix-row-cell"
                                        style={{
                                            minWidth: "140px",
                                        }}>
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            <Header name="Enable Analytics" tooltip={helpTextModel.getHelpTextForKey('Enable Analytics')} />
                                        </div>
                                    </th>
                                    <th className="matrix-row-cell"
                                        style={{
                                            minWidth: "140px",
                                        }}>
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            <Header name="Enable Feedback" tooltip={helpTextModel.getHelpTextForKey('Enable Feedback')} />
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {subcategories && subcategories.map((subcat, index) => {
                                    // //console.debug("subcat>>??", subcat)
                                    return (
                                        <tr className="matrix-row" key={index}>
                                            <td className="matrix-row-cell">{index + 1}</td>
                                            <td className="matrix-row-cell">
                                                <Checkbox size='small' checked={subcat.checked}
                                                    onClick={(event) => {
                                                        handleSelectSubcategory(event, index)
                                                    }}
                                                />
                                            </td>
                                            <td className="matrix-row-cell category-width" style={{ textAlign: 'left' }}>
                                                <div className='category-name-cell'>
                                                    <div className='category-name'>
                                                        {subcat.subcategory_name}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="matrix-row-cell">
                                                <Toggle icons={false} checked={subcat.randomize_questions === 1} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = subcat.randomize_questions === 1 ? 0 : 1;
                                                        let updatedSubcategories = [...subcategories];
                                                        updatedSubcategories[index].randomize_questions = updatedValue;
                                                        setSubcategories(updatedSubcategories);
                                                    }}
                                                />
                                            </td>
                                            <td className="matrix-row-cell">
                                                <TextField size='small' type='number' sx={{ width: "50px" }} value={subcat.subcategory_weight}
                                                    onChange={(event) => {
                                                        let updatedValue = event.target.value;
                                                        let updatedSubcategories = [...subcategories];
                                                        updatedSubcategories[index].subcategory_weight = parseInt(updatedValue);
                                                        setSubcategories(updatedSubcategories);
                                                    }}
                                                />
                                            </td>
                                            <td className="matrix-row-cell">
                                                {subcat.question_count}
                                            </td>
                                            <td className="matrix-row-cell">
                                                <Toggle icons={false} checked={subcat.non_graded === 0} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = subcat.non_graded === 0 ? 1 : 0;
                                                        let updatedSubcategories = [...subcategories];
                                                        updatedSubcategories[index].non_graded = parseInt(updatedValue);
                                                        setSubcategories(updatedSubcategories);
                                                    }}
                                                />
                                            </td>
                                            <td className="matrix-row-cell">
                                                <Toggle icons={false} checked={subcat.enable_analytics} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = !subcat.enable_analytics;
                                                        let updatedSubcategories = [...subcategories];
                                                        updatedSubcategories[index].enable_analytics = updatedValue;
                                                        setSubcategories(updatedSubcategories);
                                                    }}
                                                />
                                            </td>
                                            <td className="matrix-row-cell">
                                                <Toggle icons={false} checked={subcat.enable_feedback} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = !subcat.enable_feedback;
                                                        let updatedSubcategories = [...subcategories];
                                                        updatedSubcategories[index].enable_feedback = updatedValue;
                                                        setSubcategories(updatedSubcategories);
                                                    }}
                                                />
                                            </td>
                                        </tr>

                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={handleClose}>
                        Cancel
                    </Button>

                    <Button disabled={loading} variant='contained'
                        onClick={handleUpdateAssignment}
                        className='button-container'>
                        <div style={{ opacity: loading ? 0 : 1 }}>
                            Save
                        </div>
                        <div className='abs-center'>
                            {loading && (
                                <CircularProgress size={20} />
                            )}
                        </div>
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    );
}

const Header = ({ name, tooltip }) => {
    return (

        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            gap: "6px",
        }} >
            <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>{name}</div>
            {tooltip ?
                <Tooltip
                    title={<Typography className='text-white' fontSize={14}>
                        {tooltip}
                    </Typography>}
                    placement='top'
                    arrow
                >
                    <span>
                        <BsInfoCircleFill color='#737373' size={14}
                            style={{
                                flexShrink: 0,
                                minWidth: "12px",
                                minHeight: "12px",
                                verticalAlign: "middle",
                                cursor: "pointer",
                            }} />
                    </span>
                </Tooltip>
                : null}
        </div>
    )
}
export default CategoryModal;
